<template>
    <rkm-application>
        <template v-if="autenticado">
            <Header @toggle="handleToggle" />

            <Sidebar :open="open" />

            <rkm-main :open="open">
                <slot />
            </rkm-main>

            <rkm-toast
                v-model="visible"
                color="success"
                no-auto-hide
                solid
                title="Atenção básica - Exportação"
            >
                O arquivo <a href="#" @click.prevent="download(exportacaoArquivoId)">{{ exportacaoArquivoNome }}</a> está pronto para download.
            </rkm-toast>
        </template>
    </rkm-application>
</template>

<script>
// Components.
import Header from '@/Layout/Components/Header'
import Sidebar from '@/Layout/Components/Sidebar'

// Mixins.
import { file, repository } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Others.
import Pusher from 'pusher-js'
import { repositoryFactory } from '@/repositories/repositoryFactory'

export default {
    components: {
        Header,
        Sidebar,
    },
    computed: {
        ...mapGetters({
            autenticacao: 'getAutenticacao',
            customer: 'getCustomer',
            exportacaoEsusEmAndamento: 'getExportacaoEsusEmAndamento',
            lotacao: 'getLotacao',
            open: 'getSidebar',
        }),
        autenticado() {
            return this.autenticacao
        },
    },
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('atencaoBasica.exportacao')
        }

        this.load()
    },
    data: () => ({
        exportacaoArquivoId: null,
        exportacaoArquivoNome: null,
        pusher: null,
        visible: false,
    }),
    methods: {
        ...mapActions([
            'setExportacaoEsusEmAndamento',
            'setLoading',
            'setSidebar',
            'unsetLoading',
        ]),
        init() {
            this.connect()

            this.pusher.subscribe(`private-${this.customer.link}-atencao-basica-exportacao-finalizada-usuario.${this.lotacao.usuarioId}`)
                .bind('ExportacaoFinalizada', (data) => {
                    this.exportacaoArquivoId = data.exportacaoArquivoId
                    this.exportacaoArquivoNome = data.exportacaoArquivoNome
                    this.visible = true
                    this.setExportacaoEsusEmAndamento(false)
                })
        },
        load() {
            if (this.exportacaoEsusEmAndamento) {
                this.init()
            }
        },
        handleToggle() {
            this.setSidebar(!this.open)
        },
        download(id) {
            this.setLoading()

            this.repositories.exportacao.download(id)
                .then(response => {
                    const file = response.headers['content-disposition'].split('filename=')[1]
                    const blob = new Blob([response.data])
                    const link = document.createElement('a')

                    link.href = URL.createObjectURL(blob)
                    link.download = file
                    link.click()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        connect() {
            if (this.pusher === null) {
                this.pusher = new Pusher(process.env.VUE_APP_WS_APP_KEY, {
                    wsHost: process.env.VUE_APP_WS_HOST,
                    wsPort: process.env.VUE_APP_WS_PORT,
                    forceTLS: false,
                    enabledTransports: ['ws'],
                    authorizer: (channel) => ({
                        authorize: (socketId, callback) => {
                            const repository = repositoryFactory.get('conectaSus.websocket')

                            repository.login({
                                    token: socketId + ':' + channel.name
                                })
                                .then(response => callback(null, { auth: response }))
                                .catch(error => console.error(error))
                        }
                    })
                })
            }
        },
        disconnect() {
            if (this.pusher) {
                this.pusher.disconnect()
                this.pusher = null
            }
        },
    },
    mixins: [file, repository],
    watch: {
        exportacaoEsusEmAndamento(value) {
            if (value) {
                this.init()
            } else {
                this.disconnect()
            }
        },
    },
}
</script>